import { render, staticRenderFns } from "./collapseTransition.vue?vue&type=template&id=4e6ed32a&"
import script from "./collapseTransition.vue?vue&type=script&lang=js&"
export * from "./collapseTransition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "collapseTransition.vue"
export default component.exports